// extracted by mini-css-extract-plugin
export var completionBody = "_jk-2";
export var completionCard = "_jk-0";
export var completionFooter = "_jk-3";
export var completionTitle = "_jk-1";